const DEFAULT_PROVIDER = '';
const PROVIDERS = [
  { label: 'Alamo', value: 'alamo' },
  { label: 'Autoeurope', value: 'autoeurope' },
  { label: 'Autoeurope New', value: 'test' },
  { label: 'Avis', value: 'avis' },
  { label: 'BspAuto', value: 'bspauto' },
  { label: 'Budget', value: 'budget' },
  { label: 'Carnect', value: 'carnect' },
  { label: 'Cars and Camper', value: 'carsandcamper' },
  { label: 'Cartrawler (Argus)', value: 'cartrawler' },
  { label: 'DerTour', value: 'dertour' },
  { label: 'DriveFTI', value: 'drivefti' },
  { label: 'Enterprise', value: 'enterprise' },
  { label: 'Ergo', value: 'erv_insurance' },
  { label: 'Europcar', value: 'europcar' },
  { label: 'Hertz', value: 'hertz' },
  { label: 'Rentalcars', value: 'rentalcars' },
  { label: 'Sunnycars', value: 'sunnycars' },
  { label: 'Wisecars', value: 'wisecars' },
];

export { DEFAULT_PROVIDER, PROVIDERS };
